import axios from "axios";

const DevAPI = axios.create();

export const baseURL = "https://iot-dev.sangsang.farm/v1";

export default DevAPI;
